<template>
  <div class="back-top" v-show="showBackTop">
    <div @click="goTop" class="back-top-btn">
      <van-icon name="back-top"/>
    </div>
  </div>
</template>

<script>
import {defineComponent, onMounted, onUnmounted, ref} from "vue";

export default defineComponent({
  name: 'BackTop',
	setup(){
      const scrollTop = ref(null);
      const showBackTop = ref(false);
      const goTop = () => {
          // 直接返回顶部
          document.body.scrollTop = document.documentElement.scrollTop = 0;
          showBackTop.value = false;
      };
      onMounted(() => {
          window.addEventListener('scroll', () => {
              scrollTop.value =
                  window.pageYOffset ||
                  document.documentElement.scrollTop ||
                  document.body.scrollTop;
              if (scrollTop.value> 500) {
                  showBackTop.value = true;
              } else {
                  showBackTop.value = false;
              }
          }, true);
      });
      onUnmounted(() => {
          window.removeEventListener('scroll', () => {
              scrollTop.value =
                  window.pageYOffset ||
                  document.documentElement.scrollTop ||
                  document.body.scrollTop;
              if (scrollTop.value > 500) {
                  showBackTop.value = true;
              } else {
                  showBackTop.value = false;
              }
          }, true);
      });
	    return{
	        scrollTop,
	        showBackTop,
          goTop,
          onMounted,
          onUnmounted
	    }
	},
});
</script>

<style scoped lang="less">
@import "../../assets/css/backtop.less";
</style>
